import type { Product } from "../types/Product";

export function getLatestStorePrice(product: Product): number {
  return product.storePrice?.[product.storePrice.length - 1] ?? 0;
}

export function getLatestStoreInventory(product: Product): number {
  return product.salesFloor?.[product.salesFloor.length - 1] ?? 0;
}

export function isAvailableAtStore(product: Product): boolean {
  return product.inStock || getLatestStoreInventory(product) > 0;
}

export function getOtherConfiguredStoreIds(
  configuredStoreIds: string[],
  currentStoreId: string
): string[] {
  const normalizedCurrentStoreId = currentStoreId.trim().toLowerCase();

  return Array.from(
    new Set(
      configuredStoreIds
        .map((storeId) => String(storeId).trim())
        .filter(Boolean)
        .filter(
          (storeId) => storeId.toLowerCase() !== normalizedCurrentStoreId
        )
    )
  );
}
